import axios from 'axios';
import config from '../config/env.config';

const API_BASE_URL = config.API_URL;

// Create axios instance
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if error is due to 401 Unauthorized and we haven't retried already
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
          
        
      try {

        if (originalRequest?.url?.includes("/user/login")) {
          return Promise.reject(error);
        }
        // if (error.response.status ===401){
        //   console.log('Full URL:', originalRequest?.baseURL + originalRequest?.url);
        //   console.log("Error At API Response => ", error.response.data.detail);
        //   throw new Error( error.response.data.detail)
          
        // }
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) { 
          throw new Error('No refresh token');
        }

        // Create a new instance to avoid interceptor loops
        const axiosInstance = axios.create({
          baseURL: API_BASE_URL,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        // Use the new instance for token refresh
        const response = await axiosInstance.post(`/api/auth/refresh`, {
          refresh_token: refreshToken,
        });

        const { access_token, refresh_token: newRefreshToken, user } = response.data;

        // Store the new tokens
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', newRefreshToken);

        // Update the authorization header for the original request
        originalRequest.headers.Authorization = `Bearer ${access_token}`;

        // Also update the default headers for future requests
        api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

        // console.log('Token refreshed successfully, retrying original request');

        // Retry the original request with new token
        return api(originalRequest);
      } catch (refreshError) {
        // console.error('Token refresh failed:', refreshError.data);

        // Clear tokens
        // localStorage.setItem("Refresh Token Error", refreshError.data)
        // localStorage.setItem("AT API ", "YES");
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');

        // Use a small timeout to ensure state updates before redirect
        setTimeout(() => {
          // console.log('Redirecting to login page due to authentication failure');
          // console.log("Please Check this ")
          // localStorage.setItem("Heloo", "Yes")
          if (window.location.pathname == "/") {
            return;
          }
          else {
            window.location.href = '/admin/login';
          }

        }, 50000);

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
